import { errorValidation } from './utils';

/**
 * Validate forms
 */
(() => {
	// Recover
	$("form[name='recover']").validate({
		ignore: [],
		...errorValidation,
		errorClass: 'form__error',
		rules: {
			'recover[email]': {
				required: true,
				email: true,
			},
		},
		messages: {
			'recover[email]': {
				required: window.translations.required,
				email: window.translations.emailInvalid,
			},
		},
		submitHandler: form => {
			form.submit();
		},
		success: function (label) {
			let name = label.attr('for');
			label.text('');
		},
	});
})();
